import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			La Tero parolas kun la Universo per kurtaj ondoj.
		</p>
		
		<p class="mb-3">
			Kurte dirite… Eĉ pli kurte…
		</p>
		
		<p class="mb-3">
			Nur la kurtaj ondoj atingas la kosmon; la longaj ne povas disŝiriĝi de la Tero.
		</p>
		
		<p class="mb-3">
			Tial parolu ni kurte – por ke oni ekaŭdu nin.
		</p>
	`
	)
}

const itemName = {
	esp: 'En kurtaj rilatoj kun la universo'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;